import { Link } from '@remix-run/react'
import { getYear } from 'date-fns'
import { useEffect, useState } from 'react'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '#app/components/ui/tooltip.tsx'
import { cn } from '#app/utils/misc.tsx'
import { baseContainerWidthClassList_textWhite } from '../classlists.tsx'
import { Icon } from '../ui/icon.tsx'

export function FooterBase() {
	const currentYear = getYear(new Date())
	const companyName = 'www.penzionsklar.cz'

	const baseInnerContainerClassList =
		baseContainerWidthClassList_textWhite +
		' px-4 lg:px-8 flex justify-between text-sm max-md:flex-col max-md:text-center'
    const insideOfBaseInnerContainerClassList = "flex flex-col gap-5 md:items-start max-md:items-center min-w-[15%]"
    const headingLinkClassList = "text-lg md:mb-3 transition-colors hover:text-highlight"

	return (
		<>
			<ScrollHideElement />

			<footer className="rounded-3xl mx-2 md:mb-2 bg-black/80 text-white shadow-md">
				<div className={`${baseInnerContainerClassList} py-12 md:py-16 lg:py-20 md:max-lg:gap-7`}>
					<div className=" text-xl font-bold flex max-md:items-center flex-col gap-5 capitalize max-md:mb-8">
						<span>Penzion Sklář</span>

						<a rel='noreferrer' href="https://www.orlovegastronomie.cz/profile-3174-penzion-sklar" target="_blank">
							<img src="https://www.orlovegastronomie.cz/images/medals/3174/laureat110_gold_cz.png"
								style={{ width: '110px', height: '110px', border: '0' }}
								alt="Penzión Sklář - Karolinka"
								title="Penzión Sklář - Karolinka"
							/>
						</a>
					</div>

					<div className={`${insideOfBaseInnerContainerClassList} max-md:mb-8`}>
						<Link to="contact" className={headingLinkClassList}>Kontakty</Link>

						<Link
							to="tel:+420608466149"
							className="flex items-center gap-5 text-white/80 transition hover:text-white max-md:mr-1"
						>
							<Icon name="custom-phone" size="md" />
							<div className='md:max-lg:flex md:max-lg:flex-col'>Telefon: <span>+420 608 466 149</span></div>
						</Link>

						<Link
							to="tel:+420602452525"
							className="flex items-center gap-5 text-white/80 transition hover:text-white max-md:mr-1"
						>
							<Icon name="mobile" size="lg" />

							<div className='md:max-lg:flex md:max-lg:flex-col'>Mobil: <span>+420 602 45 25 25</span></div>
						</Link>

						<Link
							to={`mailto:penzionsklar@seznam.cz`}
							className="flex items-center gap-5 text-white/80 transition hover:text-white max-md:mr-1"
						>
							<Icon name="envelope-closed" size="lg" />
							<div className='md:max-lg:flex md:max-lg:flex-col'>Email: <span>penzionsklar@seznam.cz</span></div>
						</Link>
					</div>

					<div className={`${insideOfBaseInnerContainerClassList} max-md:mb-8`}>
						<Link to="contact" className={headingLinkClassList}>Adresa</Link>
						<div>
							<p className="mb-2">Penzion a restaurace Sklář</p>
							<p className="mb-2">Vsetínská 48</p>
							<p>Karolinka 756 05</p>
						</div>
					</div>

					<div className={insideOfBaseInnerContainerClassList}>
						<Link to="services-and-use" className={headingLinkClassList}>O nás</Link>

						<div className="flex flex-col gap-2">
							<div>© 2023 - {currentYear}</div>
							<div>{companyName}</div>
						</div>

                        {/* <div className="flex items-center gap-2 max-md:justify-center">
							<span className="text-xs">
								Developed and Created <br className="md:hidden" />
								<a
									href="https://wochlife.com"
									target="_blank"
									rel="noreferrer"
									className="border-b border-transparent transition-all hover:border-white"
								>
									by wochlife.com
								</a>
							</span>
						</div> */}
					</div>
				</div>
			</footer>

			<div className="h-[4.5rem] lg:hidden" />
		</>
	)
}

const ScrollHideElement: React.FC = () => {
	const [isVisible, setIsVisible] = useState(true)

	useEffect(() => {
		const handleScroll = () => {
			// Find the footer element
			const footer = document.querySelector('footer')
			if (footer) {
				// Get the height of the footer element
				const footerHeight = footer.getBoundingClientRect().height

				// Calculate the last Y position based on the height of the footer
				const lastY = footerHeight - 115

				// Calculate the remaining height until the bottom of the page
				const remainingHeight =
					document.documentElement.scrollHeight - window.innerHeight

				// Check if the user has scrolled to the last XY pixels
				if (window.scrollY >= remainingHeight - lastY) {
					setIsVisible(false)
				} else {
					setIsVisible(true)
				}
			}
		}

		// Call handleScroll when the page is scrolled
		window.addEventListener('scroll', handleScroll)

		// Clean up the event listener when the component is unmounted
		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}, [])

	return (
            <div className={cn(
                !isVisible ? "lg:opacity-0" : "lg:opacity-100",
                "lg:transition z-9999 fixed bottom-8 left-8 flex items-center justify-center gap-5 max-lg:hidden")}>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Link
                                to="tel:+420608466149"
                                className="text-white/80 transition hover:text-white"
                            >
                                <Icon name="custom-phone" size="xl" />
                            </Link>
                        </TooltipTrigger>
                        <TooltipContent>Telefon: +420 608 466 149</TooltipContent>
                    </Tooltip>
                </TooltipProvider>

                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Link
                                to="tel:+420602452525"
                                className="self-center text-white/80 transition hover:text-white"
                            >
                                <Icon name="mobile" size="2xl" />
                            </Link>
                        </TooltipTrigger>
                        <TooltipContent>Mobil: +420 602 45 25 25</TooltipContent>
                    </Tooltip>
                </TooltipProvider>

                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Link
                                to={`mailto:penzionsklar@seznam.cz`}
                                className="text-white/80 transition hover:text-white"
                            >
                                <Icon name="envelope-closed" size="xl" />
                            </Link>
                        </TooltipTrigger>
                        <TooltipContent>Email: penzionsklar@seznam.cz</TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>
	)
}
